export const SearchFilterBadge = {
  bindings: {
    name: '<',
    type: '@',
  },

  template: `
    <div class="search-filter-badge badge badge-pill pointer pl-4 mb-1"
      ng-class="{
        'theme-bg theme-color-light': !$ctrl.type,
        'border border-blue-cz blue-cz pr-2': $ctrl.type === 'clear'
      }">
      <i class="fa fa-times-circle"></i>
      {{ $ctrl.name }}
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilterBadge.js